'use client';

import { useModals } from '@/contexts/ModalContext';
import { useCallback } from 'react';
import { MonetizationWidget } from '@/app/[lang]/(main)/components/shared/scenarios/SelectingFeatures';

type Props = {
  onOk: () => void;
  productId: string;
  mode?: 'topup' | 'vip';
};

export const MonetizationModal: React.FC<Props> = ({ onOk, productId, mode }) => {
  const modals = useModals();

  const onClose = useCallback(() => {
    onOk();
    modals.close(`monetizatiton-modal`);
  }, [modals, onOk]);
  return <MonetizationWidget productId={productId} onClose={onClose} mode={mode} />;
};
